import types from './types';

const setFilter = (searchOptions, api) => ({
  type: types.SET_FILTER,
  payload: {
    searchOptions,
    api
  }
});

const toggleAutomaticSpatialQuery = toggled => ({
  type: types.TOGGLE_AUTOMATIC_SPATIAL_QUERY,
  payload: {
    toggled
  }
});

export default {
  setFilter,
  toggleAutomaticSpatialQuery
};



// WEBPACK FOOTER //
// ./src/redux/dataGridFilters/actions.js